import { z } from 'zod'

export const creditNoteSummarySchema = z.object({
  id: z.number().gt(0),
  name: z.string(),
  totalAmountInCents: z.number(),
  remainingBalanceInCents: z.number(),
  appliedToInvoices: z.array(z.number())
})

export const creditNoteDetailedSchema = z.object({
  id: z.number().gt(0),
  creditNoteReference: z.string(),
  date: z.coerce.date(),
  // status: z.nativeEnum(InvoiceStatus), // TODO Sort out the API and then add this back in. The API is coming back as a string.
  totalAmountInCents: z.number(),
  vatPercentage: z.number(),
  vatAmountInCents: z.number(),
  remainingAmountInCents: z.number(),
  notes: z.string().nullable(),
  allocations: z.array(
    z.object({
      invoiceId: z.number(),
      allocatedAmountInCents: z.number(),
    })
  ),
  creditNoteItems: z.array(
    z.object({
      id: z.number(),
      description: z.string(),
      quantityInKWh: z.number(),
      tariffInCents: z.number(),
    })
  )
})

export const allocateCreditNoteSchema = z.object({
  creditNoteId: z.number(),
  allocatedAmountInCents: z.number(),
})
